import React from 'react'

export const ConnectionCreated = ({ ...props }) => (
    <div>
        Success!
    </div>
);